<ng-container *ngIf="livemode; then live; else test"></ng-container>

<ng-template #live>
  <span class="bg-green-400 rounded-md px-2 text-slate-900"> Live </span>
</ng-template>

<ng-template #test>
  <span class="bg-slate-500 rounded-md px-2"> Test </span>
</ng-template>
